



























































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class PrivacyPolicy extends Vue {

    public showReturnToRegisterButton: boolean = false;

    public mounted() {
        this.showReturnToRegisterButton = this.$route.query.source && this.$route.query.source === 'register' ? true : false;
    }

}
